import React from "react";

const ManageTranscriptionTileIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.089"
      height="22.39"
      viewBox="0 0 22.089 22.39"
    >
      <g id="AI_Icon" transform="translate(-203.298 -10.085)">
        <path
          id="Path_1887"
          data-name="Path 1887"
          d="M317.92,328.184v2.544a.754.754,0,1,0,1.508,0v-2.544h1.782a2.07,2.07,0,0,0,2.048-2.085v-1.81h2.5a.768.768,0,0,0,0-1.535h-2.5v-1.732h2.5a.768.768,0,0,0,0-1.535h-2.5v-1.73h2.5a.768.768,0,0,0,0-1.535h-2.5V314.5a2.07,2.07,0,0,0-2.048-2.085h-1.782v-2.544a.754.754,0,1,0-1.508,0v2.544h-1.7v-2.544a.754.754,0,1,0-1.508,0v2.544h-1.7v-2.544a.754.754,0,1,0-1.508,0v2.544h-1.781a2.07,2.07,0,0,0-2.049,2.085v2.138h-2.5a.768.768,0,0,0,0,1.535h2.5v1.73h-2.5a.768.768,0,0,0,0,1.535h2.5v1.732h-2.5a.768.768,0,0,0,0,1.535h2.5V326.1a2.07,2.07,0,0,0,2.049,2.085H311.5v2.544a.754.754,0,1,0,1.508,0v-2.544h1.7v2.544a.754.754,0,1,0,1.508,0v-2.544Zm-8.738-2.086V314.5a.546.546,0,0,1,.54-.55H321.21a.546.546,0,0,1,.54.55v11.6a.546.546,0,0,1-.54.55H309.723a.545.545,0,0,1-.54-.55Z"
          transform="translate(-101.124 -299.021)"
          fill={fill ? fill : "#acacac"}
        />
        <path
          id="Path_1888"
          data-name="Path 1888"
          d="M352.108,357.1v-8.773a.761.761,0,0,0-.754-.767h-8.618a.761.761,0,0,0-.754.767V357.1a.761.761,0,0,0,.754.767h8.618A.76.76,0,0,0,352.108,357.1Zm-1.508-.767h-7.109v-7.238H350.6Z"
          transform="translate(-132.704 -331.35)"
          fill={fill ? fill : "#acacac"}
        />
      </g>
    </svg>
  );
};

export default ManageTranscriptionTileIcon;
